// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"34443029","154":"51147063","453":"b9451e78"}[chunkId] + ".chunk.js";
};